__turbopack_context__.v({
  "className": "geist_mono_45b937fb-module__ZnVxoq__className",
  "variable": "geist_mono_45b937fb-module__ZnVxoq__variable",
});
